import React from 'react';

export const ColoredDateCellWrapper = ({ children }) => {
  return React.cloneElement(React.Children.only(children), {
    style: {
      backgroundColor: 'white',
    },
  });
};
